module.exports = __webpack_public_path__ + "img/sceneca_6.a145503f.png";